import OrphanClaims from '@pages/OrphanClaims.vue';

export default [
  {
    path: '/orphan-claims',
    name: 'OrphanClaims',
    component: OrphanClaims,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
    },
  },
];
